module.exports = __webpack_public_path__ + "156f32a0aa153fe57ab2f66503cb5195.svg";